// URLs come from public/runtime-config.js (loaded before the bundle), with fallbacks.
const runtime = (typeof window !== 'undefined' && window.RUNTIME_CONFIG) || {};

export const BACKEND_URL = 'https://flow888.win';
export const PLAY_NOW_URL =  'https://web.cashkings.io/';
